import { useState, useEffect } from "react";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import { columnTextField } from "utils/tables-utils";
import { Tooltip } from "@mui/material";
import {
  Collections,
  AttachFile,
  CloudDownloadOutlined,
} from "@mui/icons-material";
import ButtonSelect from "components/_refactor/button/button-select";
import { Box, Button, Typography, Checkbox } from "@material-ui/core";

export default function TableDataSheetProduct({
  data,
  loading,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  onTableChange,
  handleOpenDatasheet,
  handleOpenPhotosCatalog,
  handleDownloadDataSheet,
  handleGetZipLink,
  onSelectedItemsChange,
}) {
  const [selectAll, setSelectAll] = useState(false);
  const [dataWithSelection, setDataWithSelection] = useState([]);

  useEffect(() => {
    setDataWithSelection(
      data.map((item) => ({
        ...item,
        selected: false,
      }))
    );
    setSelectAll(false);
  }, [data]);

  useEffect(() => {
    if (onSelectedItemsChange) {
      const selectedItems = dataWithSelection
        .filter((item) => item.selected)
        .map((item) => item.Produto);
      onSelectedItemsChange(selectedItems);
    }
  }, [dataWithSelection, onSelectedItemsChange]);

  const handleSelectRow = (produtoCode) => {
    setDataWithSelection((prevData) =>
      prevData.map((item) =>
        item.Produto === produtoCode
          ? { ...item, selected: !item.selected }
          : item
      )
    );
  };

  const handleSelectAll = () => {
    setDataWithSelection((prevData) =>
      prevData.map((item) => ({
        ...item,
        selected: !selectAll,
      }))
    );
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    const allSelected = dataWithSelection.every((item) => item.selected);
    const someSelected = dataWithSelection.some((item) => item.selected);
    if (dataWithSelection.length > 0 && allSelected) {
      setSelectAll(true);
    } else if (!someSelected) {
      setSelectAll(false);
    }
  }, [dataWithSelection]);

  const handleDownloadOption = (downloadType) => {
    handleDownloadDataSheet(downloadType);
  };

  const downloadOptions = [
    { label: "Completo", value: "completo" },
    { label: "Apenas ficha", value: "apenasFicha" },
    { label: "Apenas fotos", value: "apenasFotos" },
  ];

  const columnModel = [
    {
      dataField: "selected",
      text: "",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => (
        <Checkbox
          checked={row.selected || false}
          onChange={() => handleSelectRow(row.Produto)}
          color="primary"
        />
      ),
      headerFormatter: () => (
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAll}
          color="primary"
        />
      ),
    },
    columnTextField({
      dataField: "Produto",
      text: "Código do Produto",
      align: "center",
    }),
    columnTextField({
      dataField: "DescricaoProduto",
      text: "Descrição do Produto",
      align: "left",
      style: {
        maxWidth: "20vw",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    }),
    columnTextField({
      dataField: "LinhaComercial",
      text: "Linha",
      align: "center",
    }),
    columnTextField({
      dataField: "ColecaoProduto",
      text: "Coleção",
      align: "center",
    }),
    columnTextField({
      dataField: "fichaTecnica",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Ficha Técnica">
            <AttachFile
              fontSize="small"
              onClick={() => handleOpenDatasheet(row.Produto)}
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        );
      },
    }),
    columnTextField({
      dataField: "catalogoFotos",
      text: "",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Catálogo de fotos">
            <Collections
              fontSize="small"
              onClick={() => handleOpenPhotosCatalog(row.Produto)}
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando dados..." />
      ) : (
        <ToolkitTable
          keyField="IdProduto"
          dataTable={dataWithSelection}
          columnModel={columnModel}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: onTableChange,
          }}
          pagination={{
            options: [25, 50, 100],
            totalSize: totalRegistros,
            page: currentPage + 1,
            sizePerPage: currentSizePerPage,
            defaultOption: 25,
            showTotal: true,
          }}
          CustomHeader={() => (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              className="pl-4"
              style={{ height: 60, padding: "0 24px" }}
            >
              <Typography variant="h2">Ficha de Produtos</Typography>
              <div style={{ display: "flex", gap: "10px" }}>
                <ButtonSelect
                  buttonText="Downloads"
                  options={downloadOptions}
                  onSelect={handleDownloadOption}
                  disabled={loading}
                  loading={loading}
                  startIcon={<CloudDownloadOutlined />}
                  buttonWidth="20vw"
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleGetZipLink()}
                  style={{ width: "10vw" }}
                  disabled={loading}
                >
                  Ver Links
                </Button>
              </div>
            </Box>
          )}
        />
      )}
    </div>
  );
}
